import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  locationCoordinates: {
    lat: null,
    lng: null,
  },
  address: '',
  map: null,
  bounds: null,
};

const maplibremap = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setLocationCoordinates(state, action) {
      state.locationCoordinates = action.payload;
    },
    setAddress(state, action) {
      state.address = action.payload;
    },
    setMapGlobal(state, action) {
      state.map = action.payload;
    },
    setBounds(state, action) {
      state.bounds = action.payload;
    },
  },
});

export const {
  setLocationCoordinates, setAddress, setMapGlobal, setBounds,
} = maplibremap.actions;
export default maplibremap.reducer;
